@let showLowestPriceCombo = (showLowestPriceCombo$ | async) === true && (allBoundsList$ | finObsToArray)?.length > 1;

<div class="grey-25-bg pr-xsmall-t">
  <fin-cabin-class-modal [cabinClasses$]="availableCabinClasses$"></fin-cabin-class-modal>

  <div
    [ngClass]="{
      'flex flex--row flex--middle column-gap': (isMobile$ | async) || (isFlightSelectionFiltersTestVariant$ | async),
      'flex--middle': (isMobile$ | async),
      'flex--space-around': (isMobile$ | async) && (isFlightSelectionFiltersTestVariant$ | async) === false,
      'flex--space-between': (isFlightSelectionFiltersTestVariant$ | async),
      'flex--align-end': (isFlightSelectionFiltersTestVariant$ | async) && (isMobile$ | async) === false,
    }"
  >
    <fin-flight-selection-sort-by
      *ngIf="(hideFiltersAndSorter$ | async) !== true"
      [currencyCode]="currencyCode$ | async"
      [resultsAmount]="(bounds$ | async)?.boundGroups?.length"
      [bestFlightPrice]="(bestBoundsList$ | async)?.[0]?.fareFamilies?.[0].price"
      [fastestFlightPrice]="(fastestPrice$ | async)?.toString()"
      [lowestPrice]="(lowestPrice$ | async)?.toString()"
      (sortByChange)="onSelectSortBy($event)"
      [selectedSortBy$]="selectedSortBy$"
      [isMobile$]="isMobile$"
      [ngClass]="{
        'flex-1': (isMobile$ | async),
        'flex--basis-half': (isMobile$ | async) && (isFlightSelectionFiltersTestVariant$ | async),
        'ps-small-b': (isMobile$ | async) === false && (isFlightSelectionFiltersTestVariant$ | async),
      }"
      [isFlightSelectionFiltersTestVariant$]="isFlightSelectionFiltersTestVariant$"
    />

    <fin-flight-selection-filters
      *ngIf="(hideFiltersAndSorter$ | async) !== true"
      [showFlightSelectionFilters]="showFlightSelectionFilters"
      [isTravelClassChoicesDisabled]="(boundsStatus$ | async) === AirOffersStatus.PENDING"
      [travelClasses$]="travelClasses$"
      [resultsAmount]="
        (isFlightSelectionFiltersTestVariant$ | async)
          ? (nextFilteredBounds$ | async)?.boundGroups?.length
          : (bounds$ | async)?.boundGroups?.length
      "
      [selectionPhase]="selectionPhase"
      [layoverAmounts]="layoverAmounts$ | async"
      [originLocationCode]="originLocationCode$ | async"
      [destinationLocationCode]="destinationLocationCode$ | async"
      [cabinLastRequestParam$]="lastRequestParams$"
      [filters$]="filters$"
      (setFilter)="onSetFilter($event)"
      (resetFilter)="onResetFilter($event)"
      (resetAllFilters)="onResetAllFilters($event)"
      (showSpinner)="showSpinner.emit()"
      [ngClass]="{
        'flex-1': (isMobile$ | async),
        'flex--basis-half': (isMobile$ | async) && (isFlightSelectionFiltersTestVariant$ | async),
        'ps-small-b ms-xxsmall-b': (isMobile$ | async) === false && (isFlightSelectionFiltersTestVariant$ | async),
      }"
      [isFlightSelectionFiltersTestVariant$]="isFlightSelectionFiltersTestVariant$"
      [boundsHasDirectFlights$]="boundsHasDirectFlights$"
      [allBoundsAreDirect$]="allBoundsAreDirect$"
      [amountOfDirectFlights$]="amountOfDirectFlights$"
      [showRefundability]="(isFlightSelectionFiltersTestVariant$ | async) === true ? false : true"
    />
  </div>

  <div class="flex flex--column min-height-for-filters">
    <ng-container *ngIf="(boundsStatus$ | async) === AirOffersStatus.PENDING || isLoading; else boundResults">
      <fin-loader
        class="font-body-1 flex flex--center empty-and-loading-state"
        [type]="LoaderType.EMBEDDED"
        [title]="'flightSorting.loaderText'"
      ></fin-loader>
    </ng-container>

    <ng-template #boundResults>
      <ng-container *ngIf="(boundsStatus$ | async) === AirOffersStatus.OK">
        <!-- best & other bounds-->
        <ng-container
          *ngIf="
            (selectedSortBy$ | async) === SortBy.BEST && (hideFiltersAndSorter$ | async) !== true;
            else allSortedBounds
          "
        >
          <!-- best bounds-->
          <ul class="unstyled" [class.transition-appear--animate]="bestBoundsList$ | finDelay | async">
            <li
              *ngFor="let boundObs of bestBoundsList$ | finObsToArray; let i = index"
              class="flight-item mr-xsmall-b transition-appear"
            >
              <fin-air-bounds-bound-selection
                [bound$]="boundObs"
                [boundType]="boundType"
                [currencyCode$]="currencyCode$"
                [index]="i + 1"
                [control]="control"
                [viewDetailsBtnKey]="viewDetailsBtnKey"
                [locations$]="bounds$ | finMap: 'locations'"
                [showLowestPriceCombo]="showLowestPriceCombo"
                (selectFareFamily)="selectFareFamily.emit($event)"
                (showDetails)="showDetails.emit($event)"
                (openCabinClassModal)="openCabinClassModal($event)"
                data-testid="airbound-selection"
              ></fin-air-bounds-bound-selection>
            </li>
          </ul>

          <!-- other bounds -->
          <ng-container *ngIf="otherBoundsList$ | async as otherBoundsList">
            <div class="font-heading-3 mr-small-y mr-xxsmall-x" *ngIf="otherBoundsList.length !== 0">
              <span data-testid="other-departing-flights" *ngIf="boundType === BoundType.outbound"
                >{{ 'BoundCategory.otherDeparting' | finLocalization }}
              </span>
              <span data-testid="other-returning-flights" *ngIf="boundType === BoundType.inbound">{{
                'BoundCategory.otherReturning' | finLocalization
              }}</span>
              <span>({{ otherBoundsList.length }})</span>
            </div>
            <ul class="unstyled" [class.transition-appear--animate]="otherBoundsList$ | finDelay | async">
              <li
                *ngFor="let boundObs of otherBoundsList$ | finObsToArray; let i = index"
                class="flight-item mr-xsmall-b transition-appear"
              >
                <fin-air-bounds-bound-selection
                  [bound$]="boundObs"
                  [boundType]="boundType"
                  [currencyCode$]="currencyCode$"
                  [index]="i + 1"
                  [control]="control"
                  [viewDetailsBtnKey]="viewDetailsBtnKey"
                  [locations$]="bounds$ | finMap: 'locations'"
                  [showLowestPriceCombo]="showLowestPriceCombo"
                  (selectFareFamily)="selectFareFamily.emit($event)"
                  (showDetails)="showDetails.emit($event)"
                  (openCabinClassModal)="openCabinClassModal($event)"
                  data-testid="airbound-selection"
                ></fin-air-bounds-bound-selection>
              </li>
            </ul>
          </ng-container>
        </ng-container>

        <!-- sorted lowest price/fastest bounds  -->
        <ng-template #allSortedBounds>
          <ul class="unstyled" [class.transition-appear--animate]="allBoundsList$ | finDelay | async">
            <li
              *ngFor="let boundObs of allBoundsList$ | finObsToArray; let i = index"
              class="flight-item mr-xsmall-b transition-appear"
            >
              <fin-air-bounds-bound-selection
                [bound$]="boundObs"
                [boundType]="boundType"
                [currencyCode$]="currencyCode$"
                [index]="i + 1"
                [control]="control"
                [viewDetailsBtnKey]="viewDetailsBtnKey"
                [locations$]="bounds$ | finMap: 'locations'"
                [showLowestPriceCombo]="showLowestPriceCombo"
                (selectFareFamily)="selectFareFamily.emit($event)"
                (showDetails)="showDetails.emit($event)"
                (openCabinClassModal)="openCabinClassModal($event)"
                data-testid="airbound-selection"
              ></fin-air-bounds-bound-selection>
            </li>
          </ul>
        </ng-template>

        <ng-container *ngIf="(bounds$ | async)?.boundGroups?.length === 0">
          <fin-flight-filters-empty-state (clearAllFilters)="clearAllFilters()"></fin-flight-filters-empty-state>
        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</div>
